import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const normalizeDashes = (text = "") => text.replace(/[–—]/g, "-");

const splitAttributionAndBody = (tail = "") => {
  const trimmed = String(tail || "").trim();
  if (!trimmed) return { attribution: "", body: "" };

  const bodyStarterMatch = trimmed.match(
    /\s(As|We|Our|This|That|By|To|With|In|For|From|The)\b/,
  );

  if (bodyStarterMatch?.index > 0) {
    const attribution = trimmed.slice(0, bodyStarterMatch.index).trim();
    const body = trimmed.slice(bodyStarterMatch.index).trim();
    if (attribution) return { attribution, body };
  }

  return { attribution: trimmed, body: "" };
};

const parseExecutiveSpark = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  let quote = "";
  let attribution = "";
  const bodyLines = [];

  lines.forEach((line) => {
    const normalizedLine = normalizeDashes(line);
    if (/^["“]/.test(normalizedLine) && !quote) {
      // Match: "quote text" - Attribution, “quote text” - Attribution, or quote + body on same line.
      const match = normalizedLine.match(/^["“](.+?)["”]\s*(?:-\s*(.+))?$/);
      if (match) {
        quote = match[1].trim();
        const tail = (match[2] || "").trim();
        if (tail) {
          const split = splitAttributionAndBody(tail);
          attribution = split.attribution;
          if (split.body) bodyLines.push(split.body);
        }
      } else {
        quote = normalizedLine.replace(/^["“]/, "").replace(/["”]$/, "").trim();
      }
    } else {
      bodyLines.push(normalizedLine);
    }
  });

  return { quote: quote.trim(), attribution, body: bodyLines.join(" ").trim() };
};

const ExecutiveSpark = ({ markdown = "" }) => {
  const { quote, attribution, body } = parseExecutiveSpark(markdown);
  if (!quote && !body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Executive Spark</h3>
      {quote ? (
        <div className={styles.quoteCard}>
          <p className={styles.quoteText}>"{quote}"</p>
          {attribution ? (
            <p className={styles.quoteAttribution}>— {attribution}</p>
          ) : null}
        </div>
      ) : null}
      {body ? (
        <div className={styles.card}>
          <p className={styles.paragraph}>{body}</p>
        </div>
      ) : null}
    </div>
  );
};

export default ExecutiveSpark;
